import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { createQueryClient } from '@shell/api';
import { initMiniApp } from '@shell/miniapp';
import { App } from './App';
import '@shell/theme.css';
import './app.css';

// Сказать Telegram, что приложение готово (иначе заставка висит до
// таймаута), и развернуть окно. Нужно с 10.09.2026, когда у сборки
// появилась вторая дверь — кнопка из бота: открытая ей страница живёт
// внутри Telegram. Вне Telegram обе команды не делают ничего.
initMiniApp();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Не найден элемент #root — проверьте index.html');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={createQueryClient()}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
